<template>
	<div class="study">
		<publicHeader></publicHeader>
		<careerHeader :careerNav ="careerNav"></careerHeader>
		<div class="major w1200">
			<div class="flex famous_position">
				<div class="my_position_l cl_gray">
					<img src="../../../static/icon_position.png" class="mar5" />
					<p>当前位置：<router-link to="/" class="cl_gray">首页</router-link>  >  <router-link to="/career" class="cl_gray">生涯规划</router-link>
					  >  <router-link to="/treasury" class="cl_gray">生涯宝库</router-link>  >  院校信息库</p>
				</div>
			</div>
			<div class="un_cont">
				<div class="un_nav">
					<div class="un_nav_top flex">
						<div class="famous_screen_list">
							<span class="cl_gray f18px">院校层次：</span>
							<el-select v-model="ccValue" clearable placeholder="请选择" @change="ccSelect">
								<el-option v-for="item in cc":key="item" :label="item":value="item"></el-option>
							</el-select>
						</div>
						<div class="famous_screen_list">
							<span class="cl_gray f18px">院校属地：</span>
							<el-select v-model="sdValue" clearable placeholder="请选择" @change="sdSelect">
								<el-option v-for="item in sd":key="item.id" :label="item.name":value="item.id"></el-option>
							</el-select>
						</div>
						<div class="famous_screen_list">
							<span class="cl_gray f18px">院校类型：</span>
							<el-select v-model="typeValue" clearable placeholder="请选择" @change="typeSelect">
								<el-option v-for="item in type":key="item" :label="item":value="item"></el-option>
							</el-select>
						</div>
						<div class="famous_screen_list">
							<span class="cl_gray f18px">办学性质：</span>
							<el-select v-model="natureValue" clearable placeholder="请选择" @change="natureSelect">
								<el-option v-for="item in nature":key="item" :label="item":value="item"></el-option>
							</el-select>
						</div>
					</div>
					<div class="un_nav_btm mat20">
						<div class="un_btm_screen">
							<span class="cl_gray f18px">院校特色：</span>
							<div class="uni_ts cl_gray tc">
								<div class="uni_ts_list" v-for="(item,index) in ts" :key="index" :class="{'on':item.check}" @click="featureCheck(index)">{{item.name}}</div>
							</div>
						</div>
					</div>
				</div>
				<div class="un_mid">
					<div class="un_list_cont">
						<div class="un_list" v-for="(item,index) in list" :key="index">
							<router-link :to="{ path: '/treasury_details', query: { id: item.id, type: 4}}" class="un_list_l"><img :src="item.icon" class="block" /></router-link>
							<div class="un_list_m">
								<div class="un_list_top">
									<router-link class="f26px" :to="{ path: '/treasury_details', query: { id: item.id, type: 4}}">{{item.name}}</router-link>
									<div class="un_list_feature tc f12px cl_white">
										<span v-for="(item,index) in item.featureList" :key="index" class="mar10" :class="[{'first': item == '985'},{'second': item == '211'}]">{{item}}</span>
									</div>
								</div>
								<div class="un_list_btm cl_dark f16px mat15">
									<div class="un_list_item">
										<img src="../../../static/icon_position_org.png" class="mar10" />
										<span>{{item.province_name}}{{item.city_name}}</span>
									</div>
									<div class="un_list_item">
										<span>{{item.run}}</span>
									</div>
									<div class="un_list_item">
										<span>隶属：{{item.belong}}</span>
									</div>
									<div class="un_list_item">
										<span>全国排名：{{item.nation_rank}}</span>
									</div>
								</div>
							</div>
							<router-link :to="{ path: '/treasury_details', query: { id: item.id, type: 4}}" class="un_list_r cl_white tc">详情</router-link>
						</div>
					</div>
					<div class="famous_page flex">
						<div class="famous_page_l f16px cl_gray">共 {{total}} 条记录 页次：{{currentPage}}/{{Math.ceil(total/pageSize)}}页   {{pageSize}}条/页</div>
						<div class="famous_page_r cl_dark">
							<el-pagination background layout="prev, pager, next, jumper" @size-change="handleSizeChange" 
							@current-change="handleCurrentChange" :page-size="pageSize" :current-page="currentPage" :total="total"></el-pagination>
						</div>
					</div>
				</div>
			</div>
		</div>
		<vfooter></vfooter>
	</div>
</template>

<script>
	import publicHeader from '../../components/header.vue'
	import careerHeader from '../../components/career_header.vue'
	import vfooter from '../../components/footer.vue'
	export default {
	  name: 'treasury_major',
		components: {
			publicHeader,
			careerHeader,
			vfooter,
		},
	  props: {
	    
	  },
		data () {
			return {
				careerNav: 2,	//导航
				ccValue: "", //院校层次
				cc: [],
				sdValue: "", //院校属地
				sd: [],
				typeValue: "", //院校类型
				type: [],
				natureValue: "", //办学性质
				nature: [],
				tsValue: "", //院校特色
				ts: [],
				currentPage: 1, //当前页数
				pageSize: 20, //每页数量
				total: 0, //总页数
				list: [],
			}
		},
		mounted() {
			this.getUni();
			this.getSd();
			this.getType();
			this.getNature();
			this.getTs();
			this.getList();
		},
		created() {
			
		},
		methods: {
			//院校层次
			getUni () {
				var that = this;
				that.$get("/api/careerbible/get_level_data",{})
				.then(res => {
					that.cc = res.data;
					//that.ccValue = that.cc[0];
				});
			},
			//院校属地
			getSd () {
				var that = this;
				that.$get("/api/careerbible/get_province_data",{})
				.then(res => {
					that.sd = res.data;
					// that.sdValue = that.sd[0].id;
				});
			},
			//院校类型
			getType () {
				var that = this;
				that.$get("/api/careerbible/get_type_data",{})
				.then(res => {
					that.type = res.data;
					// that.typeValue = that.type[0];
				});
			},
			//办学性质
			getNature () {
				var that = this;
				that.$get("/api/careerbible/get_run_data",{})
				.then(res => {
					that.nature = res.data;
					// that.natureValue = that.nature[0];
				});
			},
			//院校特色
			getTs () {
				var that = this;
				that.$get("/api/careerbible/get_feature_data",{})
				.then(res => {
					for (let i = 0; i < res.data.length; i++) {
						that.ts.push({check: false, name: res.data[i]})
					}
				});
			},
			//院校列表
			getList () {
				var that = this;
				var params = {};
				params.level = that.ccValue;
				params.province_id = that.sdValue;
				params.type = that.typeValue;
				params.run = that.natureValue;
				params.feature = that.tsValue;
				params.page = that.currentPage;
				params.limit = that.pageSize;
				that.$get("/api/careerbible/get_university_list_data",params)
				.then(res => {
					that.list = [];
					that.list = res.data.data;
					that.total = res.data.total;
					for (let i = 0; i < that.list.length; i++) {
						that.list[i].featureList = [];
						if (that.list[i].feature != '') {
							that.list[i].featureList = that.list[i].feature.split(",");
						}
					}
				});
			},
			
			//下拉选择
			ccSelect (e) {
				this.currentPage = 1;
				this.getList();
			},
			sdSelect (e) {
				this.currentPage = 1;
				this.getList();
			},
			typeSelect (e) {
				this.currentPage = 1;
				this.getList();
			},
			natureSelect (e) {
				this.currentPage = 1;
				this.getList();
			},
			featureCheck (e) {
				let arr = [];
				this.ts[e].check = !this.ts[e].check;
				for (let i = 0; i < this.ts.length; i++) {
					if (this.ts[i].check == true) {
						arr.push(this.ts[i].name)
					}
				}
				this.tsValue = arr.join(",");
				this.getList();
			},
			
			handleSizeChange: function (size) {
				this.pageSize = size;
				console.log(this.pageSize)  //每页下拉显示数据
			},
			handleCurrentChange: function(currentPage){
				this.currentPage = currentPage;
				this.getList();
				console.log(this.currentPage)  //点击第几页
			},
		},
	}
</script>

<style>
</style>
